import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sort-arrows-icon',
  templateUrl: './sort-arrows-icon.component.html',
  styleUrls: ['./sort-arrows-icon.component.scss']
})
export class SortArrowsIconComponent {
  @Input() direction: 'asc' | 'desc' | null = null;

  constructor() { }


}
